import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../../Search/Search";
import Title from "../../../common/Title";
import BatchList from "../../../common/BatchList";

import useBatchListState from "../../../../hooks/useBatchListState";
import { __getIMSIBatches } from "../../../../api/sim";

const IMSIBatchList = ({ isClient, client, operation }) => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getIMSIBatches, {
    client: isClient ? undefined : client,
    extraParams: { operation },
  });

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`IMSI ${operation === "imsi_create" ? "Create" : "Delete"}`}
        gutterBottom
      />
      <Search
        key={`${client}-imsi`}
        client={"sparq"}
        isImsi={true}
        operation={operation}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />
      {/* if search not active show as desired */}
      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              <Grid item>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => nav("form")}
                  >
                    {`Submit new sims`}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              changeNumber={true}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default IMSIBatchList;
